import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ClienteLayoutComponent } from './layouts/cliente-layout/cliente-layout.component';
import { AuthGuard } from './core/guards/auth.guard';

const routes: Routes = [
  {
    path: 'login',
    loadChildren: () =>
      import('./pages/login/login.module').then(m => m.LoginModule)
  },
  {
    path: '',
    component: ClienteLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'solicitud-nueva',
        loadChildren: () =>
          import('./pages/solicitud-nueva/solicitud-nueva.module').then(m => m.SolicitudNuevaModule)
      },
      {
        path: 'solicitud-listado',
        loadChildren: () =>
          import('./pages/solicitud-listado/solicitud-listado.module').then(m => m.SolicitudListadoModule)
      },
      {
        path: 'presupuesto-nuevo',
        loadChildren: () =>
          import('./pages/presupuesto-nuevo/presupuesto-nuevo.module').then(m => m.PresupuestoNuevoModule)
      },
      {
        path: 'presupuesto-listado',
        loadChildren: () =>
          import('./pages/presupuesto-listado/presupuesto-listado.module').then(m => m.PresupuestoListadoModule)
      },
      {
        path: 'chat',
        loadChildren: () =>
          import('./pages/chat/chat.module').then(m => m.ChatModule)
      },
      {
        path: 'mi-cuenta',
        loadChildren: () =>
          import('./pages/mi-cuenta/mi-cuenta.module').then(m => m.MiCuentaModule)
      },
      { path: '', redirectTo: 'solicitud-nueva', pathMatch: 'full' }
    ]
  },
  { path: '**', redirectTo: 'login' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
